export enum FilterType {
    tags = 'tags',
    dateRange = 'dateRange',
    text = 'text',
    select = 'select'
}
